export const prepareSelect = (selectOptions) => {
    selectOptions = [...selectOptions];

    return selectOptions;
};
